import PoliceBookService from "@/modules/police-books/PoliceBookService";
import {store} from "@/plugins/vuex";
import {POLICE_BOOKS_TABLE_NAME} from "@/modules/constants";
import _ from 'lodash';
import i18n from "@/shared/i18n";

let getDefaultTableData = (differentFields = []) => {
    return {
        loading: false,
        rows: [],
        pagination: {
            limit: 50,
            page: 1,
            total: 0,
        },
        ordering: 'created_at',
        expand: '',
        extraFilters: {},
        toggleColumns: {
            fields: [...getDefaultFields(), ...differentFields],
            requiredFields: ['created_at', 'file_name'],
            defaultFields: ['created_at', 'filter_data', 'file_name', 'autogenerated', 'created_by', 'type'],
        }
    }
};
let getDefaultFields = () => {
    return [
        {key: 'created_at', label: i18n.t('Created at'), sortable: true, tdClass: 'col-created-at', isVisible: true, expand: ''},
        {key: 'created_by', label: i18n.t('Created by'), sortable: true, tdClass: 'col-created-by', isVisible: true, expand: ''},
        {key: 'file_name', label: i18n.t('File Name'), sortable: true, tdClass: 'col-file-name', isVisible: true, expand: ''},
        {key: 'filter_data', label: i18n.t('Date Range'), sortable: true, tdClass: 'col-date-range', isVisible: true, expand: ''},
        {key: 'autogenerated', label: i18n.t('Autogenerated'), sortable: true, tdClass: 'col-autogenerated', isVisible: true, expand: ''},
        {key: 'type', label: i18n.t('Type'), sortable: true, tdClass: 'col-type', isVisible: true, expand: ''},
    ]
};
export default {
    namespaced: true,
    state: {
        tableData: getDefaultTableData(),
        reports: [],
        loading: false,
        modal: {
            show: false,
            object: null,
            source: null,
        },
    },
    actions: {
        showModal({commit}, {object = null, source} = {}) {
            commit('showModal', {object: _.cloneDeep(object), source});
        },
        hideModal({commit}) {
            commit('hideModal');
        },
        async getTableParams({state}, payload = null) {
            let data;
            const ordering = await store.dispatch('global/getTableDataOrdering', {
                tableData: state.tableData,
                tableName: POLICE_BOOKS_TABLE_NAME
            });
            if (payload) {
                data = {
                    ...payload.pagination,
                    ordering: payload.ordering,
                };
            } else {
                data = {
                    ...state.tableData.pagination,
                    ordering: ordering,
                }
            }
            return data;
        },
        async getTableData({commit, dispatch}, payload) {
            let params = await dispatch('getTableParams', payload);

            commit('updateTableLoading', true);
            const response = await PoliceBookService.getPoliceBooksReports(params)
            commit('updateTableLoading', false);

            if (response.success && response.body.results) {
                commit('updateTableData', {
                    rows: response.body.results,
                    pagination: {limit: params.limit, page: params.page, total: response.body.count},
                    ordering: params.ordering,
                });
            }

            return response;
        },
        async updateToggleColumns({commit, dispatch}, payload) {
            if (payload.isSaveAction) {
                commit('updateTableLoading', true);
                await commit('updateToggleColumns', payload.selectedColumns);
                await dispatch('getTableData');
                commit('updateTableLoading', false);
            } else {
                await commit('updateToggleColumns', payload.selectedColumns);
            }
        },
        async getReports({commit}) {
            commit('changeLoading', true);
            const response = await PoliceBookService.getPoliceBooksReports();

            commit('changeLoading', false);
            if (response.success) {
                commit('getReports', response.body);
            }
            return response;
        },
        async removePoliceBookReport({dispatch}, report) {
            let response = await PoliceBookService.removePoliceBookReport(report.uuid);
            if (response.success) {
                dispatch('getTableData');
            }
            return response;
        },
    },
    mutations: {
        updateTableData: (state, payload) => state.tableData = {...state.tableData, ...payload},
        updateTableLoading: (state, payload) => state.tableData.loading = payload,
        changeLoading: (state, payload) => state.loading = payload,

        getReports: (state, payload) => state.reports = payload,

        showModal: (state, {object, source}) => {
            state.modal.show = true;
            state.modal.object = object;
            state.modal.source = source;
        },
        hideModal: state => state.modal.show = false,
        updateToggleColumns: (state, selectedColumns) => {
            state.tableData.toggleColumns.defaultFields = [...selectedColumns];
            let selectedFields = [];
            let notSelectedFields = [];
            selectedColumns.forEach(s => {
                selectedFields.push({
                    ...state.tableData.toggleColumns.fields.find(f => f.key === s),
                    isVisible: true
                });
            });
            state.tableData.toggleColumns.fields.forEach(f => {
                if (!selectedColumns.includes(f.key)) {
                    notSelectedFields.push({...f, isVisible: false});
                }
            });
            state.tableData.toggleColumns.fields = [...selectedFields, ...notSelectedFields];
        },
    }
}
